<template>
    <div class="ui-date-range-picker-candidate ui-picker-date">
        <!-- * 日期选择器头部 -->
        <div class="ui-candidates-header">
            <!-- * 左侧控制器 -->
            <div class="ui-candidates-controls ui-candidates-left">
                <!-- * 年份控制器 -->
                <div class="ui-candidates-control ui-candidates-year" @click="methods.date({ year: date.getFullYear() - 1 })">
                    <UiIcon name="arrow-double" />
                </div>

                <!-- * 月份控制器 -->
                <div class="ui-candidates-control ui-candidates-month" @click="methods.date({ month: date.getMonth() - 1 })">
                    <UiIcon name="arrow" />
                </div>
            </div>

            <!-- * 日期年月信息 -->
            <div class="ui-candidates-context" @click="$emit('switchover', 'month')">
                <span>{{ date.getFullYear() }}年</span>
                <span>{{ date.getMonth() + 1 }}月</span>
            </div>

            <!-- * 右侧控制器 -->
            <div class="ui-candidates-controls ui-candidates-right">
                <!-- * 月份控制器 -->
                <div class="ui-candidates-control ui-candidates-month" @click="methods.date({ month: date.getMonth() + 1 })">
                    <UiIcon name="arrow" />
                </div>

                <!-- * 年份控制器 -->
                <div class="ui-candidates-control ui-candidates-year" @click="methods.date({ year: date.getFullYear() + 1 })">
                    <UiIcon name="arrow-double" />
                </div>
            </div>
        </div>

        <!-- * 日期选择器内容 -->
        <div class="ui-candidates-date">
            <div class="ui-candidate-context">一</div>
            <div class="ui-candidate-context">二</div>
            <div class="ui-candidate-context">三</div>
            <div class="ui-candidate-context">四</div>
            <div class="ui-candidate-context">五</div>
            <div class="ui-candidate-context">六</div>
            <div class="ui-candidate-context">日</div>
            <template v-for="value in days" :key="value.date">
                <div class="ui-candidate" :class="methods.get_day_status(value)" v-on="ons.day(value)">
                    {{ value.day }}
                </div>
            </template>
        </div>
    </div>
</template>

<script lang="ts" setup>
//* 组件引入
import UiIcon from "@various/components/icon";

//* 组件属性
import { ModulePickerEmits } from "../../src/types";
import { useComposable } from "./src/composable";

//* 组件属性注册
const emits = defineEmits(ModulePickerEmits);

//* 组合函数
const { ons, refs, methods } = useComposable(emits);
const { init, update } = methods;
const { date, days } = refs;

//* 声明组件配置
defineExpose({ init, update });
</script>
